import React, { useState, useEffect, useMemo } from "react";
import iconClose from "../../../assets/img/iconClose.svg";
import Helpers from "../../../helpers/shared.helper";
import planFG from "../../../services/planFg.service";
import Plans from "../../../services/plans.service";
import Storage from "../../../services/storage.service";
import Translations from "../../../services/translation.service";
import User from "../../../services/user.service";

const subscriptions = [];

const prefix = "content_services_";
const ContentServiceModal = () => {

  // const logoImages = JSON.parse(Storage.get("stf_streaming_img", true))
  const handleToggleModal = () => {
    Storage.set("StreamModal",
      {
        'SHOW': false,
        'TYPE': "",
        'Plan_type': "",
        'PLAN': "",
        'content_list': '',
        'planData': ''
      });
  }
  // const contentServicesStorage = JSON.parse(
  //   Storage.get("content_services", true)
  // );

  // const ContentImages = [
  //   {
  //     id: 1,
  //     image: contentServicesStorage.services_anghami?.url,
  //   },
  //   {
  //     id: 2,
  //     image: contentServicesStorage.services_starzplay?.url,
  //   },
  //   {
  //     id: 3,
  //     image: contentServicesStorage.services_osn?.url,
  //   },
  //   {
  //     id: 4,
  //     image: contentServicesStorage.services_ufc?.url,
  //   },
  //   {
  //     id: 5,
  //     image: contentServicesStorage.services_discovery?.url,
  //   },
  //   {
  //     id: 6,
  //     image: contentServicesStorage.services_blutv?.url,
  //   },
  // ];

  // const [updatedOptions, setUpdatedOptions] = useState(ContentImages);

  // const getImagesFromStore = useCallback((item) => {
  //   const contentServicesStorage = JSON.parse(
  //     Storage.get("content_services", true)
  //   );
  //   switch (item.Type) {
  //     case "ANGHAMI":
  //       return contentServicesStorage.services_anghami?.url;
  //     case "STARZPLAY":
  //       return contentServicesStorage.services_starzplay?.url;
  //     case "OSN":
  //       return contentServicesStorage.services_osn?.url;
  //     case "UFC":
  //       return contentServicesStorage.services_ufc?.url;
  //     case "Discovery":
  //       return contentServicesStorage.services_discovery?.url;
  //     case "DATA-SOCIAL":
  //       return contentServicesStorage.services_blutv?.url;
  //     default:
  //   }
  //   return "";
  // },[]);

  // useEffect(() => {
  //   const formattedPromotions = options.map((item) => ({
  //     image: getImagesFromStore(JSON.parse(item.Value)),
  //   }));
  //   if(formattedPromotions.length){
  //     setUpdatedOptions(formattedPromotions);
  //   }
  // }, [getImagesFromStore, options]);

  // const handleClick = () => {
  //   handleButtonClick();
  //   handleToggleModal();
  // };

  // useEffect(() => {
  //   document.body.classList.add("disable-scroll");
  //   return () => {
  //     document.body.classList.remove("disable-scroll");
  //   };
  // }, []);

  const [duration, setDuration] = useState("");
  const [translationsKeys, setTranslationsKeys] = useState(Translations.keys ? Translations.keys : {});
  const [contentServiceList, setContentServiceList] = useState([]);
  const [StreamModal, setStreamModal] = useState([]);
  const [showList, setShowList] = useState(false);
  const [durationUnit, setDurationUnit] = useState("");
  // const [loader, setLoader] = useState(true);

  useEffect(() => {
    // setLoader(true);
    subscriptions.push(
      Translations.getKeysObsrv().subscribe(data => {
        setTranslationsKeys(data);
        // setLoader(false);
      })
    )
    subscriptions.push(
      Storage.get_obsrv("StreamModal").subscribe(data => {
        setStreamModal(data)
        if (data?.content_list?.length) {
          document.body.classList.add("disable-scroll");
          setContentServiceList(data?.content_list);
          getDuration(data?.content_list)
          setShowList(true);
        } else if (!data?.SHOW) {
          setShowList(false);
        }
      })
    );

    return () => {
      document.body.classList.remove("disable-scroll");
      if (subscriptions && subscriptions?.length) {
        for (let subscription of subscriptions) {
          subscription.unsubscribe();
        }
      }
    }

  }, []);

  const getDuration = (options) => {
    let durationField = "";

    let durationData = options?.[0]?.Value?.PromotionDuration
    // options?.[0]?.Value?.PromotionDuration === 0 ?
    // options?.[0]?.Value?.PromotionDuration :
    // options?.[0]?.Value?.PromotionDuration;
    if (durationData === -1) {//If unlimited
      durationField = -1
    } else {
      durationField = Helpers.monthsInDay(durationData) + " ";

      if (durationField === 1) {
        setDurationUnit("stf_offer_duration_label_singular");
      } else {
        setDurationUnit("stf_offer_duration_label_plural");
        if (options?.[0]?.extended_validity) {
          let extendedValidityInMonths = Helpers.monthsInDay(options?.[0]?.extended_validity);
          durationField = Helpers.monthsInDay(durationData - options?.[0]?.extended_validity) +
            ' + ' + extendedValidityInMonths;
        } 
      }
    }
    setDuration(durationField)
  }

  const handleClick = () => {
    if (StreamModal.Plan_type === "WP_PLAN") {
      doStreamSubmit();
      setShowList(false);
    } else {
      setShowList(false);
      Storage.set("contentServiceSave",
        {
          'planData': StreamModal?.planData,
          'Plan_type': StreamModal?.Plan_type,
        });
      Storage.set("contentServiceSave", true);
    }
  };

  const doStreamSubmit = () => {
    Storage.set("selected_plan_id", StreamModal?.PLAN?.plan_ids, true)
    switch (StreamModal.TYPE) {
      case 'STORAGE_PARAMS_PRD_BUNDLE':
        Plans.saveBundleFromParams(StreamModal?.PLAN?.product_code, StreamModal?.PLAN)
          .then(response => {
            User.fetchFlowStatus(4).then(response => {
              Storage.set("wp_loader", false);
              Storage.set("StreamModal", {});
            }).catch(err => {
              Storage.set("StreamModal", {});
            })
          }).catch(error => { });
        break;
      case 'SAVE_PREDEFINED_FG':
        planFG.saveFGplan(StreamModal?.PLAN?.product_code, StreamModal?.PLAN?.plan_ids)
          .then(response => {
            User.fetchFlowStatus(4).then(response => {
              Storage.set("StreamModal", {});
            }).catch(err => {
              Storage.set("StreamModal", {});
            })
          }).catch(error => { Storage.set("StreamModal", {}); });
        break;
      default:
    }
  }

  // const getServiceTextImage = (service_type) => {
  //   const planImagesData = JSON.parse(
  //     Storage.get("content_services_description", true)
  //   );
  //   let requiredPlanImage = "";
  //   if (planImagesData) {
  //     requiredPlanImage = planImagesData[`services_image_description_${service_type.toLowerCase()}`]?.url;
  //   }
  //   return requiredPlanImage;
  // }

  const getServiceImage = (service_type) => {
    const contentServicesStorage = JSON.parse(
      Storage.get("content_services", true)
    );
    let requiredPlanImage = "";
    if (contentServicesStorage) {
      requiredPlanImage = contentServicesStorage[`services_${service_type.toLowerCase()}_full`]?.url;
    }
    return requiredPlanImage;
  }

  const description = useMemo(() => {
    const nameArray = contentServiceList.map((item) => {
      const value = typeof item?.Value === "string" ? JSON.parse(item.Value) : (item?.Value || "")
      return translationsKeys[`stf-content-service-name-${value?.Type}`]
    })
    return `(${nameArray.join(", ")})`
  }, [contentServiceList]) // eslint-disable-line react-hooks/exhaustive-deps


  return (
    <>{
      showList ?

        <div className="content-service-modal-overlay" onClick={handleToggleModal}>
          <div className="content-service-modal-wrapper" onClick={(e) => e.stopPropagation()}>
            {Helpers.isMobile() && <div className="content-service-close-modal">
              <img
                className="cross-icon"
                src={iconClose}
                alt={"close"}
                onClick={handleToggleModal}
              />
            </div>}
            <div className="header-section">
              {contentServiceList.map((item, index) => (
                <div className="image-container">
                  <img className="backgroudnd-image" src={getServiceImage(item?.Value?.Type)} alt={""} />
                  {/* {!!logoImages && logoImages[ImageTypes[item?.Value?.Type]]?.url && <img className="service-logo" src={logoImages[ImageTypes[item?.Value?.Type]]?.url} alt={""} />} */}
                </div>
              ))}
            </div>
            <div className="text-section">
              <p className="heading">{translationsKeys["content_service_month_dis"] || "Included one content service"}
                {" "}
                {duration && duration !== -1 ?
                  <> {translationsKeys["content_service_month_for"] || "for"}
                    {" "}
                    {duration + " "}
                    {translationsKeys[durationUnit] || "month"}</>
                  : null}
              </p>
              <p className="description">
                {translationsKeys[prefix + "prefix_description"]}{description}{translationsKeys[prefix + "suffix_description"]}
              </p>
            </div>
            <button onClick={() => { handleClick() }}>{translationsKeys[prefix + "btn_continue"]}</button>
          </div>
        </div> : null}
    </>
  );
};

export default ContentServiceModal;
